import { z } from 'zod';
/** Résultat d'une ligne `OC1` — `03` §2 (`fulfillmentLines.result`) et `01` §5.3. */
export const FULFILLMENT_LINE_RESULTS = [
    'fulfilled',
    'already_fulfilled',
    'state_updated',
    'ignored',
    'simulated',
    'error',
];
export const fulfillmentLineResultSchema = z.enum(FULFILLMENT_LINE_RESULTS);
export const FULFILLMENT_LINE_RESULT = {
    fulfilled: {
        code: 'fulfilled',
        label: 'Expédiée',
        tone: 'green',
        description: 'Fulfillment créé dans Shopify avec le numéro de suivi.',
    },
    already_fulfilled: {
        code: 'already_fulfilled',
        label: 'Déjà expédiée',
        tone: 'gray',
        description: 'Aucun fulfillment order ouvert ; rien à créer.',
    },
    state_updated: {
        code: 'state_updated',
        label: 'État mis à jour',
        tone: 'blue',
        description: 'Retour sans numéro de suivi : seul l’état Martelet est enregistré.',
    },
    ignored: {
        code: 'ignored',
        label: 'Ignorée',
        tone: 'gray',
        description: 'Ligne écartée (facture Pennylane, ou ignorée manuellement).',
    },
    simulated: {
        code: 'simulated',
        label: 'Simulée',
        tone: 'blue',
        description: 'Mode simulation : le résultat attendu a été calculé sans écrire dans Shopify.',
    },
    error: { code: 'error', label: 'En erreur', tone: 'red' },
};
/** Statut d'un fichier `O_COMMANDES` — `03` §2 (`fulfillmentFiles.status`). */
export const FULFILLMENT_FILE_STATUSES = [
    'simulated',
    'processed',
    'processed_with_errors',
    'failed',
];
export const fulfillmentFileStatusSchema = z.enum(FULFILLMENT_FILE_STATUSES);
export const FULFILLMENT_FILE_STATUS = {
    simulated: {
        code: 'simulated',
        label: 'Simulé',
        tone: 'blue',
        description: 'Lu en simulation ; sera repris par le premier run réel.',
    },
    processed: { code: 'processed', label: 'Traité', tone: 'green' },
    processed_with_errors: {
        code: 'processed_with_errors',
        label: 'Traité avec erreurs',
        tone: 'orange',
    },
    failed: { code: 'failed', label: 'Échec', tone: 'red' },
};
/**
 * État Martelet lu sur une ligne de retour `OC1` (`01` §5.3). Il ne vit plus
 * sur la commande — c'est désormais son statut unique qui porte l'information
 * (`integrated`, `prepared`, `shipped` dans `ORDER_STATUS`). Ce registre ne
 * sert qu'à afficher le détail d'une ligne de run.
 */
export const MARTELET_STATES = ['integrated', 'prepared', 'shipped'];
export const marteletStateSchema = z.enum(MARTELET_STATES);
export const MARTELET_STATE = {
    integrated: { code: 'integrated', label: 'Intégrée', tone: 'blue' },
    prepared: { code: 'prepared', label: 'Préparée', tone: 'blue' },
    shipped: { code: 'shipped', label: 'Expédiée', tone: 'green' },
};
//# sourceMappingURL=fulfillment.js.map